import ViewAllAppointments from "../components/his/appointments/ViewAllAppointments";
import { formatDate } from "../utils/FormateDateTime";
import { statusTemplate } from "../utils/squenceTableNo";

export const AppointmentTabs = (
  t,
  payloadData,
  setPayloadData,
  fetchAppointmentLIst,
  data,
  loading,
  dataref
) => ({
  tabs: [
    // { name: t('Pending'), content: <ViewAllAppointments query='Pending' /> },
    {
      name: t("Booked"),
      content: (
        <ViewAllAppointments
          query="Booked"
          payloadData={payloadData}
          setPayloadData={setPayloadData}
          fetchAppointmentLIst={fetchAppointmentLIst}
          data={data}
          loading={loading}
          dataref={dataref}
        />
      ),
    },
    {
      name: t("Cancelled"),
      content: (
        <ViewAllAppointments
          query="Cancelled"
          payloadData={payloadData}
          setPayloadData={setPayloadData}
          fetchAppointmentLIst={fetchAppointmentLIst}
          data={data}
          loading={loading}
          dataref={dataref}
        />
      ),
    },
  ],
  className: "custom-class",
});

export const AppTableFields = (t, payloadData) => [
  { header: t("Id"), field: "appointment_id" },

  { header: t("PatientName"), field: "patient.full_name" },
  { header: t("Contact"), field: "patient.contact" },
  { header: t("DocumentId"), field: "patient.document_id" },
  { header: t("MRN"), field: "patient.file_no" },
  { header: t("Date"), body: (row) => formatDate(row?.appointment_date) },
  { header: t("Day"), field: "day" },
  { header: t("StartTime"), field: "start_time" },
  { header: t("EndTime"), field: "end_time" },
  { header: t("Practitioner"), field: "practitioner.name" },
  { header: t("Notes"), field: "note" },
  { header: t("Created By"), field: "created_by" },
  ...(payloadData?.filters?.status == "Cancelled" ||
    payloadData?.filters?.status == ""
    ? [
      {
        header: t("Cancelled By"),
        field: "cancelled_by",
        bodyCell: " !whitespace-pre-wrap",
      },
      {
        header: t("Cancel Reason"),
        field: "cancellation_reason.text",
        bodyCell: " !whitespace-pre-wrap",
      },
    ]
    : []),
  { header: t("Status"), body: statusTemplate },

];

export const AppointmentTypesTableColumns = (t) => [
  { header: t("TypeName"), field: "type_name" },
  { header: t("Description"), field: "description" },
];
export const appointmentsOptions = [
  { label: "General Consultation", value: "general" },
  { label: "Pediatrics", value: "pediatrics" },
  { label: "Cardiology", value: "cardiology" },
  { label: "Orthopedics", value: "orthopedics" },
  { label: "Dermatology", value: "dermatology" },
];

export const intervalOptions = [
  { value: "5", label: "5 Min" },
  { value: "10", label: "10 Min" },
  { value: "15", label: "15 Min" },
  { value: "20", label: "20 Min" },
  { value: "25", label: "25 Min" },
  { value: "30", label: "30 Min" },
  { value: "35", label: "35 Min" },
  { value: "40", label: "40 Min" },
  { value: "45", label: "45 Min" },
  { value: "50", label: "50 Min" },
  { value: "55", label: "55 Min" },
  { value: "60", label: "60 Min" },
];

export const statusOptions = [
  { value: "Available", label: "Available" },
  { value: "UnAvailable", label: "Un Available" },
];

export const daysOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
  { value: "Sunday", label: "Sunday" },
];

export const appointmentTypesOptions = (data = []) => {
  return data?.map((data) => {
    return {
      label: data?.type_name,
      value: data?.id,
      data,
    };
  });
};

export const appointmentCalenderEvents = [
  // June 10
  {
    id: 1,
    title: "Doctor Appointment",
    start: new Date(2025, 5, 10, 9, 0, 0),
    end: new Date(2025, 5, 10, 9, 30, 0),
  },
  {
    id: 2,
    title: "Daily Standup",
    start: new Date(2025, 5, 10, 10, 0, 0),
    end: new Date(2025, 5, 10, 10, 15, 0),
  },
  {
    id: 3,
    title: "Team Check-in",
    start: new Date(2025, 5, 10, 13, 0, 0),
    end: new Date(2025, 5, 10, 14, 0, 0),
  },

  // June 12
  {
    id: 4,
    title: "Weekly Sync",
    start: new Date(2025, 5, 12, 10, 0, 0),
    end: new Date(2025, 5, 12, 11, 0, 0),
  },
  {
    id: 5,
    title: "Content Planning",
    start: new Date(2025, 5, 12, 12, 30, 0),
    end: new Date(2025, 5, 12, 13, 30, 0),
  },

  // June 14
  {
    id: 6,
    title: "Sprint Review",
    start: new Date(2025, 5, 14, 11, 0, 0),
    end: new Date(2025, 5, 14, 12, 0, 0),
    patientName: "John Doe",
    doctor: "Dr. Smith",
    notes: "Bring previous reports.",
  },
  {
    id: 7,
    title: "Project Review Meeting",
    start: new Date(2025, 5, 14, 14, 0, 0),
    end: new Date(2025, 5, 14, 15, 30, 0),
    patientName: "John Doe",
    doctor: "Dr. Smith",
    notes: "Bring previous reports.",
  },
  {
    id: 8,
    title: "Team Celebration",
    start: new Date(2025, 5, 14, 17, 0, 0),
    end: new Date(2025, 5, 14, 19, 0, 0),
  },
  {
    id: 16,
    title: "Sprint Review",
    start: new Date(2025, 5, 14, 11, 12, 0),
    end: new Date(2025, 5, 14, 12, 28, 0),
  },
  {
    id: 77,
    title: "Project Review Meeting",
    start: new Date(2025, 5, 14, 14, 30, 0),
    end: new Date(2025, 5, 14, 16, 30, 0),
  },
  {
    id: 18,
    title: "Team Celebration",
    start: new Date(2025, 5, 14, 17, 0, 0),
    end: new Date(2025, 5, 14, 19, 0, 0),
  },

  // June 18
  {
    id: 9,
    title: "Product Launch Planning",
    start: new Date(2025, 5, 18, 11, 0, 0),
    end: new Date(2025, 5, 18, 12, 30, 0),
  },
  {
    id: 10,
    title: "Vendor Call",
    start: new Date(2025, 5, 18, 13, 0, 0),
    end: new Date(2025, 5, 18, 13, 45, 0),
  },

  // June 21
  {
    id: 11,
    title: "Design Presentation",
    start: new Date(2025, 5, 21, 9, 30, 0),
    end: new Date(2025, 5, 21, 10, 30, 0),
  },
  {
    id: 12,
    title: "Budget Review",
    start: new Date(2025, 5, 21, 11, 0, 0),
    end: new Date(2025, 5, 21, 12, 0, 0),
  },

  // June 23
  {
    id: 13,
    title: "Marketing Strategy Review",
    start: new Date(2025, 5, 23, 10, 0, 0),
    end: new Date(2025, 5, 23, 11, 0, 0),
  },
  {
    id: 14,
    title: "UI Testing",
    start: new Date(2025, 5, 23, 13, 30, 0),
    end: new Date(2025, 5, 23, 15, 0, 0),
  },

  // June 25
  {
    id: 15,
    title: "Final Testing Deadline",
    start: new Date(2025, 5, 25, 8, 0, 0),
    end: new Date(2025, 5, 25, 11, 0, 0),
  },
  {
    id: 16,
    title: "Stakeholder Demo",
    start: new Date(2025, 5, 25, 13, 0, 0),
    end: new Date(2025, 5, 25, 14, 30, 0),
  },
  {
    id: 17,
    title: "Feedback Session",
    start: new Date(2025, 5, 25, 15, 0, 0),
    end: new Date(2025, 5, 25, 16, 0, 0),
  },
];

export const priorityOptions = [
  {
    label: "ASAP",
    value: "A",
    definition: "As soon as possible, next highest priority after stat.",
  },
  {
    label: "Callback Results",
    value: "CR",
    definition:
      "Filler should contact the placer as soon as results are available, even for preliminary results.",
  },
  {
    label: "Elective",
    value: "EL",
    definition: "Beneficial to the patient but not essential for survival.",
  },
  {
    label: "Emergency",
    value: "EM",
    definition:
      "An unforeseen combination of circumstances or the resulting state that calls for immediate action.",
  },
  {
    label: "Pre-op",
    value: "P",
    definition:
      "Used to indicate that a service is to be performed prior to a scheduled surgery. When ordering a service and using the pre-op priority, a check is done to see the amount of time that must be allowed for performance of the service. When the order is placed, a message can be generated indicating the time needed for the service so that it is not ordered in conflict with a scheduled operation.",
  },
  {
    label: "As Needed",
    value: "PRN",
    definition:
      'An "as needed" order should be accompanied by a description of what constitutes a need. This description is represented by an observation service predicate as a precondition.',
  },
  {
    label: "Routine",
    value: "R",
    definition: "Routine service, do at usual work hours.",
  },
  {
    label: "Rush Reporting",
    value: "RR",
    definition: "A report should be prepared and sent as quickly as possible.",
  },
  {
    label: "Stat",
    value: "S",
    definition: "With highest priority (e.g., emergency).",
  },
  {
    label: "Timing Critical",
    value: "T",
    definition:
      "It is critical to come as close as possible to the requested time (e.g., for a through antimicrobial level).",
  },
  {
    label: "Use As Directed",
    value: "UD",
    definition: "Drug is to be used as directed by the prescriber.",
  },
  {
    label: "Urgent",
    value: "UR",
    definition: "Calls for prompt action.",
  },
];

export const appointmentTypeOptions = [
  {
    label: "Routine Appointment",
    value: "ROUTINE",
    system: "http://terminology.hl7.org/CodeSystem/v2-0276",
    definition: "Routine appointment - default if not valued",
  },
  {
    label: "Walk-in Visit",
    value: "WALKIN",
    system: "http://terminology.hl7.org/CodeSystem/v2-0276",
    definition: "A previously unscheduled walk-in visit",
  },
  {
    label: "Check-up",
    value: "CHECKUP",
    system: "http://terminology.hl7.org/CodeSystem/v2-0276",
    definition: "A routine check-up, such as an annual physical",
  },
  {
    label: "Follow-up",
    value: "FOLLOWUP",
    system: "http://terminology.hl7.org/CodeSystem/v2-0276",
    definition: "A follow up visit from a previous appointment",
  },
  {
    label: "Emergency Appointment",
    value: "EMERGENCY",
    system: "http://terminology.hl7.org/CodeSystem/v2-0276",
    definition: "Emergency appointment",
  },
];

export const participantStatusOptions = [
  {
    label: "Accepted",
    value: "accepted",
    definition: "The participant has accepted the appointment.",
  },
  {
    label: "Declined",
    value: "declined",
    definition:
      "The participant has declined the appointment and will not participate in the appointment.",
  },
  {
    label: "Tentative",
    value: "tentative",
    definition:
      "The participant has tentatively accepted the appointment. This could be automatically created by a system and requires further processing before it can be accepted. There is no commitment that attendance will occur.",
  },
  {
    label: "Needs Action",
    value: "needs-action",
    definition:
      "The participant needs to indicate if they accept the appointment by changing this status to one of the other statuses.",
  },
];
